// extracted by mini-css-extract-plugin
export var header = "_x3-1";
export var maskBottom = "_x3-6";
export var maskMiddle = "_x3-7";
export var maskTop = "_x3-5";
export var root = "_x3-0";
export var scrollDownButton = "_x3-3";
export var scrollDownButtonHidden = "_x3-4";
export var viewport = "_x3-2";